import React, { useEffect, useState } from "react";
import { FormGroup } from "@mui/material";
import CoreInputField from "../../../app/core/components/CoreInputField/CoreInputField";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import CoreTextArea from "../../../app/core/components/CoreTextArea/CoreTextArea";
import { toast } from "react-toastify";
import { ROLE, SUB_ROLE } from "../../../utils/constants/profiles";
import CoreSelect from "../../../app/core/components/CoreSelect/CoreSelect";
import CoreDialog from "../../../app/core/components/CoreDialog/CoreDialog";
import {
  useDeleteCommercialistaMutation,
  useSaveCommercialistaMutation,
} from "../../api/admin/gestisciCommercialistiApi";
import { useNavigate } from "react-router-dom";
import CoreSelectObjArr from "../../../app/core/components/CoreSelect/CoreSelectObjArr";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useGetStudiosQuery } from "../../api/admin/gestisciStudioApi";
import StudioFilter from "../../../app/core/components/UserFilter/StudioFilter";
import { adminStudioApi } from "../../api/admin/gestisciStudioApi";
import { TABLE_ROWS_NUMBER } from "../../../utils/constants/tables";
import { useGetRolesQuery } from "../../api/admin/rolesApi";

const FormOperator = ({ operatorData, onClose }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [studio, setStudio] = useState({
    label: operatorData?.Data?.studioName || "",
    id: operatorData?.Data?.studioId,
  });
  const [formData, setFormData] = useState({
    Name: operatorData.Data.name,
    Surname: operatorData.Data.surname,
    Email: operatorData.Data.email,
    LicenseCount: operatorData.Data.licenseCount,
    Notes: operatorData.Data.notes || "",
    StudioName: operatorData?.Data?.studioName,
    StudioId: operatorData?.Data?.studioId,
    SubRole: operatorData.Data.subRole,
    adminProfileRoles: [
      operatorData.Data.adminProfileRoles[0]?.identityRole?.role,
    ],
  });

  const [validationErrors, setValidationErrors] = useState({});
  const [showConfirmUserDialog, setShowConfirmUserDialog] = useState(false);
  const [debouncedInputStudioValue, setDebouncedInputStudioValue] =
    useState("");
  const page = {
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  };

  const role = useSelector((state) => state.app.role);
  const appConfig = useSelector((state) => state.app.appConfig);

  const { data: adminRoles } = useGetRolesQuery({});
  const { data: studios } = useGetStudiosQuery({
    ...page,
    value: debouncedInputStudioValue,
  });

  const OPERATOR_TYPES = adminRoles?.Data.map((type) => ({
    label: type.name,
    value: type.role,
  }));

  const [saveCommercialista, { isLoading: isLoadingSave }] =
    useSaveCommercialistaMutation();
  const [deleteCommercialista, { isLoading: isLoadingDelete }] =
    useDeleteCommercialistaMutation();

  useEffect(() => {
    if (studio)
      setFormData({
        ...formData,
        StudioId: studio.id,
        StudioName: studio.label,
      });
    else
      setFormData({
        ...formData,
        StudioId: "",
        StudioName: "",
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studio?.id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "adminProfileRoles") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: [value],
      }));
      return;
    }
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleDelete = () => {
    setShowConfirmUserDialog(true);
  };

  const handleCloseDialod = () => {
    setShowConfirmUserDialog(false);
  };

  const handleConfermDialog = (id) => {
    const idToast = toast.loading(t("Deleting..."), {
      pauseOnFocusLoss: false,
      type: "info",
    });

    deleteCommercialista(id)
      .then((res) => {
        if (res.data.Result !== 1) {
          toast.update(idToast, {
            render: res.data.Exception || `${t("OperatorNotDeleted")}`,
            type: "error",
            autoClose: 1500,
            isLoading: false,
          });
          handleCloseDialod();
          if (role === ROLE.BUSINESS) onClose();
          if (role === ROLE.ADMIN) navigate(-1);
          return;
        }

        toast.update(idToast, {
          render: `${t("OperatorDeleted")}`,
          type: "success",
          autoClose: 1500,
          isLoading: false,
        });
        handleCloseDialod();
        if (role === ROLE.BUSINESS) onClose();
        if (role === ROLE.ADMIN) navigate(-1);
      })
      .catch(() => {
        toast.update(idToast, {
          render: `${t("OperatorNotDeleted")}`,
          type: "error",
          autoClose: 1500,
          isLoading: false,
        });
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setValidationErrors({});
    const errors = {};
    if (!formData.StudioId) errors.StudioId = `${t("SelectStudio")}`;

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    const editData = {
      id: operatorData.Data.id,
      name: formData.Name,
      surname: formData.Surname,
      email: formData.Email,
      licenseCount: formData.LicenseCount,
      notes: formData.Notes,
      subRole: formData.SubRole,
      studioId: formData.StudioId ? formData.StudioId : null,
    };
    if (formData.adminProfileRoles[0]) {
      editData.adminProfileRoles = formData.adminProfileRoles;
    }

    saveCommercialista(editData)
      .then((res) => {
        if (res.data.Exception) {
          toast.error(res.data.Exception);
        } else if (res.data.Data) {
          toast.success(`${t("OperatorUpdated")}`);
          dispatch(adminStudioApi.util.invalidateTags(["studios"]));
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  return (
    <div className="flex flex-col w-full ">
      <h3>Dati</h3>
      <div className="flex space-x-10">
        <FormGroup className="w-full">
          <CoreInputField
            label={t("Name")}
            name="Name"
            onChange={handleChange}
            value={formData.Name}
          />
        </FormGroup>
        <FormGroup className="w-full">
          <CoreInputField
            label={t("Surname")}
            name="Surname"
            onChange={handleChange}
            value={formData.Surname}
          />
        </FormGroup>
      </div>

      <div className="flex space-x-10">
        <FormGroup className="w-full">
          <CoreInputField
            label="Email"
            name="Email"
            onChange={handleChange}
            value={formData.Email}
          />
        </FormGroup>
      </div>
      <div className="flex space-x-10">
        {/* <FormGroup className="w-full">
          <CoreInputField
            label={t("License")}
            name="LicenseCount"
            onChange={handleChange}
            value={formData.LicenseCount}
          />
        </FormGroup> */}
        <FormGroup className="w-full pt-6">
          <StudioFilter
            selectedUser={studio}
            setSelectedUser={(v) => {
              setStudio(v);
              setValidationErrors((prev) => ({ ...prev, StudioId: "" }));
            }}
            usersList={studios?.Data?.items}
            setDebouncedInputUserValue={setDebouncedInputStudioValue}
            disabled={role !== ROLE.ADMIN}
            isError={validationErrors.StudioId}
          />
        </FormGroup>
      </div>
      <div className="pt-8">
        <FormGroup className="w-full">
          <CoreSelect
            onChange={handleChange}
            name={"SubRole"}
            label={t("Role")}
            items={SUB_ROLE}
            value={formData.SubRole}
          />
        </FormGroup>
      </div>
      {appConfig?.modules?.studio?.adminProfileRoles && (
        <div className="pt-8">
          <FormGroup className="w-full">
            <CoreSelectObjArr
              name="adminProfileRoles"
              label={t("OperatorType")}
              value={formData.adminProfileRoles}
              items={OPERATOR_TYPES}
              onChange={handleChange}
              isFull={true}
              className="w-full"
            />
          </FormGroup>
        </div>
      )}
      <div className="flex flex-col py-7">
        <FormGroup className="w-full">
          <CoreTextArea
            label={t("Notes")}
            rows={5}
            name="Notes"
            onChange={handleChange}
            value={formData.Notes}
          />
        </FormGroup>
      </div>
      <div className="flex justify-around py-5">
        <CoreButton
          testo={t("Delete")}
          className="bg-red-700 btn-round border-red-700"
          onClick={handleDelete}
          disabled={isLoadingSave}
        />
        <CoreButton
          testo={isLoadingDelete ? t("Wait") : t("Save")}
          className="btn-round"
          onClick={handleSubmit}
          disabled={isLoadingSave}
        />
      </div>
      <CoreDialog
        open={showConfirmUserDialog}
        title={`${t("Delete")} ${t("operator")}`}
        content={`${t("OperatorDeletingConfirm")} ${operatorData?.Data?.name} ${
          operatorData?.Data?.surname
        }?`}
        negativeButton={t("No")}
        positiveButton={t("Yes")}
        handlePositive={() => handleConfermDialog(operatorData.Data.id)}
        closeDialog={handleCloseDialod}
      />
    </div>
  );
};

export default FormOperator;
